/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable camelcase */
/* eslint-disable react/jsx-pascal-case */
/* eslint-disable react/jsx-no-undef */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable prefer-const */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable no-restricted-syntax */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/destructuring-assignment */
import { Badge, Group, Space, Text, ThemeIcon } from '@mantine/core';
import { IconFilter, IconList, IconShare } from '@tabler/icons-react';
import { Tabs } from 'antd';
import { MRT_ColumnDef, MRT_RowSelectionState } from 'mantine-react-table';
import { useEffect, useMemo, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Status, TipoCodigo } from '../../../../../business/events/general';
import {
  CustomTable,
  DefaultCell,
  DefaultValue,
} from '../../../../../components/core/CustomTable/CustomTable';
import ProfileCardLink from '../../../../../components/core/ProfileCardLink/ProfileCardLink';
import useCurrentUser from '../../../../../hooks/useCurrentUser';
import { EventSearchResponseType } from '../../../../../models/core/events.type';
import { UserType } from '../../../../../models/core/users.type';
import { Feature } from '../../../../../utils/constants.utils';
import { formatDateToString } from '../../../../../utils/formatter.utils';
import { newGuid } from '../../../../../utils/helper.utils';
import DataViewActions from './DataViewActions';
import DataViewBulkActions from './DataViewBulkActions';

type DataViewProps = {
  users: UserType[];
  data: EventSearchResponseType[] | undefined;
  // eslint-disable-next-line react/no-unused-prop-types
  showDocs: boolean;
  confirmActionResult(
    items: EventSearchResponseType[],
    action: string,
    value: string | null,
    confirmed: boolean,
    extras: any
  ): void;
  extras: any;
};

export default function DataView(props: DataViewProps) {
  const [currentUser] = useCurrentUser();
  const queryParams = new URLSearchParams(useLocation().search);
  const pageFilter = queryParams.get('filter') || '';

  const [rowSelection, setRowSelection] = useState<MRT_RowSelectionState>({});

  // TODO: App: 118 - context api works better here
  const [tempSelectedData, setTempSelectedData] = useState<number[]>([]);
  const [selectedData, setSelectedData] = useState<
    {
      idEvento: number;
      idContrato: number | null;
      idEntidade: number | null;
      idProposta: number | null;
      idEventoVeiculoCompartilhado: number | null;
      codigoEventoStatus: Status;
      codigoEventoTipo: TipoCodigo;
      data: Date;
      observacao: string | null;
    }[]
  >([]);

  const columns = useMemo<MRT_ColumnDef<EventSearchResponseType>[]>(() => {
    const data: MRT_ColumnDef<EventSearchResponseType>[] = [
      {
        header: '#',
        id: 'idEvento',
        accessorKey: 'idEvento',
        sortingFn: (a, b) => a.original.idEvento - b.original.idEvento,
        Cell: ({ row }) => (
          <Link to={`?id=${row.original.idEvento}`} target="_blank">
            <Text size="sm" c={row.original.obsoleto ? 'red' : 'green'}>
              {row.original.idEvento}
            </Text>
          </Link>
        ),
        size: 60,
      },
      {
        header: 'Tipo',
        accessorKey: 'eventoTipo',
        sortingFn: (a, b) => a.original.eventoTipo.localeCompare(b.original.eventoTipo),
        Cell: ({ cell }) => <Badge variant="outline">{cell.getValue<string>()}</Badge>,
      },
      {
        header: 'Fonte',
        id: 'fonrte',
        accessorFn: (row) => row.idContrato || row.idEntidade || row.idProposta || DefaultValue,
        sortingFn: (a, b) => {
          const aValue = a.original.idContrato
            ? `C${a.original.idContrato}`
            : a.original.idEntidade
            ? `E${a.original.idEntidade}`
            : a.original.idProposta
            ? `P${a.original.idProposta}`
            : '-';
          const bValue = b.original.idContrato
            ? `C${b.original.idContrato}`
            : b.original.idEntidade
            ? `E${b.original.idEntidade}`
            : b.original.idProposta
            ? `P${b.original.idProposta}`
            : '-';
          return aValue.localeCompare(bValue);
        },
        Cell: ({ cell, renderedCellValue, row }) => {
          const entry = row.original;

          if (entry.idContrato) {
            return (
              <ProfileCardLink
                id={entry.idContrato.toString()}
                name="Contrato"
                nameSize="sm"
                description={`# ${entry.idContrato}`}
                descriptionSize="xs"
                linkPrefix="contracts"
                showLink
              />
            );
          }
          if (entry.idEntidade) {
            return (
              <ProfileCardLink
                id={entry.idEntidade.toString()}
                name="Entidade"
                nameSize="sm"
                description={`# ${entry.idEntidade}`}
                descriptionSize="xs"
                linkPrefix="entities"
                showLink
              />
            );
          }
          if (entry.idProposta) {
            return (
              <ProfileCardLink
                id={entry.idProposta.toString()}
                name="Proposta"
                nameSize="sm"
                description={`# ${entry.idProposta}`}
                descriptionSize="xs"
                linkPrefix="proposals"
                showLink
              />
            );
          }

          return DefaultCell({ cell, renderedCellValue });
        },
      },
      {
        header: 'Cliente/Entidade',
        id: 'cliente',
        accessorFn: (row) => {
          const { cliente, entidade } = row.resumoParcialJSON || {};
          if (!cliente && !entidade) return DefaultValue;
          return `${cliente?.clienteNomeFantasia ?? ''}|${cliente?.clienteRazaoSocial ?? ''}|${
            cliente?.clienteNome ?? ''
          }|${cliente?.clienteCNPJ ?? ''}|${cliente?.clienteCPF ?? ''}|${entidade?.nomeFantasia ?? ''}|${
            entidade?.razaoSocial ?? ''
          }|${entidade?.nome ?? ''}|${entidade?.cnpj ?? ''}|${entidade?.cpf ?? ''}`;
        },
        sortingFn: (a, b) => {
          const clienteA = a.original.resumoParcialJSON?.cliente;
          const entidadeA = a.original.resumoParcialJSON?.entidade;
          const aValue =
            clienteA?.clienteNomeFantasia ||
            clienteA?.clienteRazaoSocial ||
            clienteA?.clienteNome ||
            entidadeA?.nomeFantasia ||
            entidadeA?.razaoSocial ||
            entidadeA?.nome ||
            '-';

          const clienteB = b.original.resumoParcialJSON?.cliente;
          const entidadeB = b.original.resumoParcialJSON?.entidade;
          const bValue =
            clienteB?.clienteNomeFantasia ||
            clienteB?.clienteRazaoSocial ||
            clienteB?.clienteNome ||
            entidadeB?.nomeFantasia ||
            entidadeB?.razaoSocial ||
            entidadeB?.nome ||
            '-';

          return aValue.localeCompare(bValue);
        },
        Cell: ({ cell, renderedCellValue, row }) => {
          const { cliente, entidade } = row.original.resumoParcialJSON || {};
          if (!cliente && !entidade) return DefaultCell({ cell, renderedCellValue });

          const entidadeRender = {
            id: cliente?.idCliente || entidade?.idEntidade,
            cnpj: cliente?.clienteCNPJ || entidade?.cnpj,
            nomePJ:
              cliente?.clienteNomeFantasia ||
              cliente?.clienteRazaoSocial ||
              entidade?.nomeFantasia ||
              entidade?.razaoSocial,
            descricaoPJ:
              cliente?.clienteNomeFantasia || entidade?.nomeFantasia
                ? cliente?.clienteRazaoSocial || entidade?.razaoSocial
                : cliente?.clienteCNPJ || entidade?.cnpj,
            nomePF: cliente?.clienteNome || entidade?.nome,
            descricaoPF: cliente?.clienteCPF || entidade?.cpf,
          };
          return (
            <ProfileCardLink
              id={entidadeRender.id?.toString() || ''}
              name={entidadeRender.nomePJ || entidadeRender.nomePF || '?'}
              nameSize="sm"
              description={entidadeRender.descricaoPJ || entidadeRender.descricaoPF}
              descriptionSize="xs"
              linkPrefix="entities"
              showLink
            />
          );
        },
      },
      {
        header: 'Descrição',
        id: 'descricao',
        accessorFn: (row) => {
          let value = row.automatico
            ? row.descricao
            : `${
                row.resumoParcialJSON?.residuo?.residuoCliente ||
                row.resumoParcialJSON?.servico?.servico ||
                '-'
              } | ${row.descricao}`;
          if (value.startsWith('- |')) {
            value = value.replace('- |', '');
          }
          if (value.endsWith(' | -')) {
            value = value.replace(' | -', '');
          }
          return ['-', ''].includes(value.trim()) ? DefaultValue : value;
        },
        sortingFn: (a, b) => {
          const aValue = a.original.automatico
            ? a.original.descricao
            : a.original.resumoParcialJSON?.residuo?.residuoCliente ||
              a.original.resumoParcialJSON?.servico?.servico ||
              a.original.descricao ||
              DefaultValue;
          const bValue = b.original.automatico
            ? b.original.descricao
            : b.original.resumoParcialJSON?.residuo?.residuoCliente ||
              b.original.resumoParcialJSON?.servico?.servico ||
              b.original.descricao ||
              DefaultValue;
          return aValue.localeCompare(bValue);
        },
        Cell: ({ cell, renderedCellValue }) => DefaultCell({ cell, renderedCellValue }),
      },
      {
        header: 'Status',
        accessorKey: 'eventoStatus',
        sortingFn: (a, b) => a.original.eventoStatus.localeCompare(b.original.eventoStatus),
        Cell: ({ cell }) => <Badge variant="outline">{cell.getValue<string>()}</Badge>,
      },
      {
        header: 'Data',
        id: 'data',
        accessorFn: (row) => new Date(row.data),
        filterVariant: 'date-range',
        sortingFn: 'datetime',
        enableColumnFilterModes: false,
        Cell: ({ cell }) =>
          cell.getValue<Date>() ? formatDateToString(cell.getValue<Date>()) : DefaultValue,
      },
      {
        header: 'Responsável',
        id: 'responsavel',
        accessorFn: (row) => (row.idResponsavel ? row.responsavel : DefaultValue),
        Cell: ({ cell, renderedCellValue, row }) => {
          const entry = row.original;
          if (!entry.idResponsavel) return DefaultCell({ cell, renderedCellValue });
          return (
            <ProfileCardLink id={entry.idResponsavel!.toString()} name={entry.responsavel!} nameSize="sm" />
          );
        },
      },
      {
        header: 'Compartilhamento',
        id: 'idEventoVeiculoCompartilhado',
        accessorFn: (row) => row.idEventoVeiculoCompartilhado || DefaultValue,
        sortingFn: (a, b) => (a.original.idEvento ?? -1) - (b.original.idEvento ?? -1),
        Cell: ({ cell, renderedCellValue, row }) => {
          const entry = row.original;
          if (!entry.idEventoVeiculoCompartilhado) return DefaultCell({ cell, renderedCellValue });
          return (
            <Group gap={2}>
              <div>F{entry.idEventoVeiculoCompartilhado}</div>
              {!entry.resumoParcialJSON?.veiculoCompartilhado ? <IconShare size={16} /> : <></>}
            </Group>
          );
        },
      },
      {
        header: 'Obsoleto?',
        id: 'obsoleto',
        accessorFn: (row) => (row.obsoleto ? 'Sim' : 'Não'),
        filterVariant: 'checkbox',
        columnFilterModeOptions: ['Sim', 'Não'],
        filterFn: (row, id, filterValue) => {
          if (!filterValue?.length) return true;
          const finalFilterValue = filterValue === 'true' ? 'Sim' : 'Não';
          return finalFilterValue === row.getValue(id);
        },
        Cell: ({ cell }) => (
          <Badge variant="outline" color={cell.getValue() === 'Sim' ? 'red' : 'green'} size="sm">
            {cell.getValue<string>()}
          </Badge>
        ),
      },
    ];

    if (currentUser.executivo) {
      data.splice(1, 0, {
        header: 'Empresa',
        id: 'empresa',
        accessorFn: (row) => row.empresa,
        Cell: ({ cell }) => <Badge variant="outline">{cell.getValue<string>()}</Badge>,
      });
    }

    if (!pageFilter) {
      data.splice(currentUser.executivo ? 2 : 1, 0, {
        header: 'Audiência',
        accessorKey: 'eventoAudiencia',
        sortingFn: (a, b) => a.original.eventoAudiencia.localeCompare(b.original.eventoAudiencia),
        Cell: ({ cell }) => <Badge variant="outline">{cell.getValue<string>()}</Badge>,
      });
    }

    if (props.showDocs) {
      data.splice(data.length - 1, 0, {
        header: 'Documentos',
        id: 'documentos',
        accessorFn: (row) => {
          return (
            row.resumoParcialJSON?.documentos
              ?.map((x) => `${x.documentoTipo}|${x.numeroDocumento}`)
              ?.join(',') || DefaultValue
          );
        },
        Cell: ({ cell, renderedCellValue, row }) => {
          const entry = row.original;
          const documentos = entry.resumoParcialJSON?.documentos || [];
          if (documentos.length > 0) {
            return (
              <Group gap="xs">
                {documentos.map((y) => {
                  return (
                    <Badge
                      key={newGuid()}
                      variant="outline"
                    >{`${y.documentoTipo} - ${y.numeroDocumento}`}</Badge>
                  );
                })}
              </Group>
            );
          }
          return DefaultCell({ cell, renderedCellValue });
        },
      });

      // columns.splice(columns.length - 1, 0, {
      //   title: 'Documentos',
      //   key: 'documentos',
      //   sorter: (a: EventSearchResponseType, b: EventSearchResponseType) => {
      //     const aValue = (a.resumoParcialJSON?.documentos || []).length;
      //     const bValue = (b.resumoParcialJSON?.documentos || []).length;
      //     if (aValue === bValue) {
      //       return 0;
      //     }
      //     return aValue > bValue ? 1 : -1;
      //   },
      //   render: (row: EventSearchResponseType) => {
      //     const documentos = row.resumoParcialJSON?.documentos || [];
      //     if (documentos.length > 0) {
      //       return (
      //         <Group gap="xs">
      //           {documentos.map((y) => {
      //             return (
      //               <Badge
      //                 key={newGuid()}
      //                 variant="outline"
      //               >{`${y.documentoTipo} - ${y.numeroDocumento}`}</Badge>
      //             );
      //           })}
      //         </Group>
      //       );
      //     }
      //     return '-';
      //   },
      // });
    }

    return data;
  }, []);

  const handleRowSelectionChange = (updater: any) => {
    const newRowSelection = typeof updater === 'function' ? updater(rowSelection) : updater;
    setRowSelection(newRowSelection);

    setSelectedData(
      (props.data || [])
        .filter((x) => Object.keys(newRowSelection).includes(x.idEvento.toString()))
        .map((y) => {
          return {
            idEvento: y.idEvento,
            idContrato: y.idContrato,
            idEntidade: y.idEntidade,
            idProposta: y.idProposta,
            idEventoVeiculoCompartilhado: y.idEventoVeiculoCompartilhado,
            codigoEventoStatus: y.codigoEventoStatus,
            codigoEventoTipo: y.codigoEventoTipo,
            data: y.data,
            observacao: y.observacao,
            // resumoParcialJSON: x.resumoParcialJSON,
          };
        })
    );
  };

  const buildResultsWithNoPageFilter = () => {
    return (
      <div>
        <CustomTable
          columns={columns}
          data={props.data ?? []}
          initialState={{
            columnVisibility: {
              empresa: false,
              eventoAudiencia: false,
              obsoleto: false,
            },
          }}
          mantinePaginationProps={{ rowsPerPageOptions: ['10', '25', '50', '100', '250', '500'] }}
          globalFilterFn="contains"
          enableRowActions
          enableRowSelection
          enableBatchRowSelection
          enableMultiRowSelection
          selectAllMode="all"
          getRowId={(row) => row.idEvento.toString()}
          // onRowSelectionChange={setRowSelection}
          onRowSelectionChange={handleRowSelectionChange}
          state={{ rowSelection }}
          positionActionsColumn="last"
          displayColumnDefOptions={{ 'mrt-row-actions': { size: 170 } }}
          renderRowActions={(renderProps) => (
            <DataViewActions
              extras={props.extras}
              item={renderProps.row.original}
              confirmActionResult={props.confirmActionResult}
            />
          )}
        />
      </div>
    );
  };

  const buildResultsWithPageFilter = useMemo(() => {
    const tabs = [
      {
        key: 'Todos',
        label: (
          <Group>
            <ThemeIcon color={Feature.Home.Event.color} variant="outline">
              <IconList size={18} />
            </ThemeIcon>
            <Text size="md" color={Feature.Home.Event.color} style={{ fontWeight: 500 }}>
              Todos ({props.data?.length})
            </Text>
          </Group>
        ),
        children: (
          <CustomTable
            columns={columns}
            data={props.data ?? []}
            initialState={{ columnVisibility: { empresa: false, obsoleto: false } }}
            mantinePaginationProps={{ rowsPerPageOptions: ['10', '25', '50', '100', '250', '500'] }}
            globalFilterFn="contains"
            enableRowActions
            enableRowSelection
            enableBatchRowSelection
            enableMultiRowSelection
            selectAllMode="all"
            getRowId={(row) => row.idEvento.toString()}
            // onRowSelectionChange={setRowSelection}
            onRowSelectionChange={handleRowSelectionChange}
            state={{ rowSelection }}
            positionActionsColumn="last"
            displayColumnDefOptions={{ 'mrt-row-actions': { size: 170 } }}
            renderRowActions={(renderProps) => (
              <DataViewActions
                extras={props.extras}
                item={renderProps.row.original}
                confirmActionResult={props.confirmActionResult}
              />
            )}
          />
        ),
        forceRender: true,
      },
    ];

    for (const tipo of Array.from(new Set((props?.data || []).map((x) => x.eventoTipo)))) {
      const tipoData = (props?.data || []).filter((x: any) => x?.eventoTipo === tipo);

      tabs.push({
        key: tipo,
        label: (
          <Group>
            <ThemeIcon color={Feature.Home.Event.color} variant="outline">
              <IconFilter size={18} />
            </ThemeIcon>
            <Text size="md" color={Feature.Home.Event.color} style={{ fontWeight: 500 }}>
              {tipo} ({tipoData.length})
            </Text>
          </Group>
        ),
        children: (
          <CustomTable
            columns={columns.filter((x) => x.accessorKey !== 'eventoTipo')}
            data={tipoData}
            initialState={{ columnVisibility: { empresa: false, obsoleto: false } }}
            mantinePaginationProps={{ rowsPerPageOptions: ['10', '25', '50', '100', '250', '500'] }}
            globalFilterFn="contains"
            enableRowActions
            enableRowSelection
            enableBatchRowSelection
            enableMultiRowSelection
            selectAllMode="all"
            getRowId={(row) => row.idEvento.toString()}
            // onRowSelectionChange={setRowSelection}
            onRowSelectionChange={handleRowSelectionChange}
            state={{ rowSelection }}
            positionActionsColumn="last"
            displayColumnDefOptions={{ 'mrt-row-actions': { size: 170 } }}
            renderRowActions={(renderProps) => (
              <DataViewActions
                extras={props.extras}
                item={renderProps.row.original}
                confirmActionResult={props.confirmActionResult}
              />
            )}
          />
        ),
        forceRender: true,
      });
    }

    return <Tabs items={tabs} defaultActiveKey="Todos" />;
  }, [columns, props.data]);

  const confirmActionResult = (
    items: EventSearchResponseType[],
    action: string,
    value: string | null,
    confirmed: boolean
  ) => {
    props.confirmActionResult(items, action, value, confirmed, props.extras);
    setTempSelectedData(items.map((x) => x.idEvento));
  };

  useEffect(() => {
    if (props.data?.length === 0) {
      setSelectedData([]);
    }

    if (tempSelectedData.length > 0) {
      setSelectedData(props.data?.filter((x) => tempSelectedData.includes(x.idEvento)) || []);
    }
  }, [props.data]);

  return (
    <div>
      <DataViewBulkActions
        users={props.users}
        data={props.data || []}
        selectedData={selectedData}
        confirmActionResults={confirmActionResult}
      />
      <Space h="sm" />

      {pageFilter ? buildResultsWithPageFilter : buildResultsWithNoPageFilter()}
    </div>
  );
}
